/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyCount
 */
export interface ProxyCount {
    /**
     * 
     * @type {number}
     * @memberof ProxyCount
     */
    count: number;
}

export function ProxyCountFromJSON(json: any): ProxyCount {
    return ProxyCountFromJSONTyped(json, false);
}

export function ProxyCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function ProxyCountToJSON(value?: ProxyCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}


